export enum EDelkyZemi {
    // IBAN Countries
    AL = 28,
    BH = 22,
    BY = 28,
    BA = 20,
    SV = 28,
    GE = 22,
    IQ = 23,
    XK = 20,
    LC = 32,
    ST = 25,
    SC = 31,
    TL = 23,
    UA = 29,
    VG = 24,
    AD = 24,
    AE = 23,
    AT = 20,
    AZ = 28,
    BE = 16,
    BG = 22,
    BR = 29,
    CH = 21,
    CR = 21,
    CY = 28,
    CZ = 24,
    DE = 22,
    DK = 18,
    DO = 28,
    EE = 20,
    ES = 24,
    FI = 18,
    FO = 18,
    FR = 27,
    GB = 22,
    GI = 23,
    GL = 18,
    GR = 27,
    GT = 28,
    HR = 21,
    HU = 28,
    IE = 22,
    IL = 23,
    IS = 26,
    IT = 27,
    JO = 30,
    KW = 30,
    KZ = 20,
    LB = 28,
    LI = 21,
    LT = 20,
    LU = 20,
    LV = 21,
    MC = 27,
    MD = 24,
    ME = 22,
    MK = 19,
    MR = 27,
    MT = 31,
    MU = 30,
    NL = 18,
    NO = 15,
    PK = 24,
    PL = 28,
    PS = 29,
    PT = 25,
    QA = 29,
    RO = 24,
    RS = 22,
    SA = 24,
    SE = 24,
    SI = 19,
    SK = 24,
    SM = 27,
    TN = 24,
    TR = 26,

    // Partial IBAN Countries (Experimental)
    DZ = 26,
    AO = 25,
    BJ = 28,
    BF = 28,
    BI = 16,
    CM = 27,
    CV = 25,
    CF = 27,
    TD = 27,
    KM = 27,
    CG = 27,
    DJ = 27,
    EG = 27,
    GQ = 27,
    GA = 27,
    GW = 25,
    HN = 28,
    IR = 26,
    CI = 28,
    MG = 27,
    ML = 28,
    MA = 28,
    MZ = 25,
    NI = 32,
    NE = 28,
    SN = 28,
    TG = 28
}
